import type { Order } from '@order/graphql';

import { useValidOrders } from './useValidOrders';

/**
 * Returns last placed valid* order from cache
 *
 * valid = either a pickup or outpost order or a delivery order with active delivery address.
 */
export const useLastValidOrder = (): Order | undefined => {
  const validOrders = useValidOrders();

  return validOrders[0];
};
